export default __webpack_public_path__ + "static/media/friesland_logo.9f8804ef.svg";